import { UsersEmptyState } from '@fluentsms/agentnet-web-icons';
import { PartyOrderInsightsProps } from 'api/file/interfaces/get-file-order-insights';
import { NON_FA_UW_PARTY_VERIFICATION_HEADING } from 'features/help/constants';
import NonFaUwEmptyState, { DisabledNonFaUwProduct } from 'features/services/shared/NonFaUwEmptyState';

interface PartyVerificationNonFaUwEmptyStateProps {
  hasFraudValidationRights?: boolean;
  agentNetAdmin?: boolean;
  enableStatus: PartyOrderInsightsProps['enableStatus'];
  onAddNewVerification: () => void;
}

// Products are always available for First American, so the firm level status reports
// whether each one has been enabled for the firm's other underwriters.
const getDisabledNonFaUwProducts = (
  enableStatus: PartyOrderInsightsProps['enableStatus'],
): DisabledNonFaUwProduct[] => {
  const products: DisabledNonFaUwProduct[] = [];

  if (!enableStatus?.contactValidation?.enabled) {
    products.push({
      name: 'Contact Validation',
      productCode: enableStatus?.contactValidation?.productCode,
      linkTestId: 'party-verification-link-contact-validation',
    });
  }

  if (!enableStatus?.enhancedIdentityVerification?.enabled) {
    products.push({
      name: 'Identity Verification',
      productCode: enableStatus?.enhancedIdentityVerification?.productCode,
      linkTestId: 'party-verification-link-identity-verification',
    });
  }

  return products;
};

const PartyVerificationNonFaUwEmptyState = ({
  hasFraudValidationRights,
  agentNetAdmin,
  enableStatus,
  onAddNewVerification,
}: PartyVerificationNonFaUwEmptyStateProps) => (
  <NonFaUwEmptyState
    icon={<UsersEmptyState />}
    headerText="No Verifications"
    descriptionText="Start verifying parties by clicking “New Verification” below."
    actionLabel="New Verification"
    onAction={onAddNewVerification}
    isActionDisabled={!hasFraudValidationRights}
    actionTestId="party-verification-new-verification-button-bottom"
    agentNetAdmin={agentNetAdmin}
    promptHeading={NON_FA_UW_PARTY_VERIFICATION_HEADING}
    disabledProducts={getDisabledNonFaUwProducts(enableStatus)}
    promptTestId="party-verification-non-fa-underwriter-prompt"
  />
);

export default PartyVerificationNonFaUwEmptyState;
